import React, { Component } from 'react'

import { Container, InnerContainer, Title, Text, Link } from './styles'
import { AUTH_TOKEN, SELECTED_BRANCH, HOOK_URL, OCI } from '../../constants'

class Error extends Component {
  handleLogOut() {
    if (window.localStorage.getItem(AUTH_TOKEN)) {
      window.localStorage.removeItem(AUTH_TOKEN)
    } else {
      window.sessionStorage.removeItem(AUTH_TOKEN)
    }
    if (window.localStorage.getItem(SELECTED_BRANCH)) {
      window.localStorage.removeItem(SELECTED_BRANCH)
    } else {
      window.sessionStorage.removeItem(SELECTED_BRANCH)
    }
    if (window.sessionStorage.getItem(HOOK_URL)) {
      window.sessionStorage.removeItem(HOOK_URL)
    }
    if (window.sessionStorage.getItem(OCI)) {
      window.sessionStorage.removeItem(OCI)
    }
    window.location.reload()
  }

  handleRefresh() {
    window.location.reload()
  }

  render() {
    document.body.classList.add('error')
    return (
      <Container>
        <InnerContainer>
          <Title>Er is een fout opgetreden</Title>
          {this.props.message ? (
            <Text>{this.props.message}</Text>
          ) : (
            <Text>
              Er is een fout opgetreden bij het ophalen van {this.props.error}, dit kan betekenen dat een handeling een
              storing heeft veroorzaakt of dat er een probleem met de verbinding is ontstaan.
            </Text>
          )}
          <Text>
            Probeer de pagina te <Link onClick={this.handleRefresh.bind(this)}>verversen</Link> of{' '}
            <Link onClick={this.handleLogOut.bind(this)}>log uit</Link> en probeer het opnieuw.
          </Text>
          <Text>
            Helpt dit niet? <br />Stuur dan een mail naar{' '}
            <a href="mailto:portal@kaarskoffie.nl">portal@kaarskoffie.nl</a>
          </Text>
        </InnerContainer>
      </Container>
    )
  }
}

export default Error



// WEBPACK FOOTER //
// ./src/components/Error/index.js